import React, {Fragment, FunctionComponent} from 'react';
import {Typography} from '@material-ui/core';

import LabeledLinks from '../common/LabeledLinks';
import LabeledText from '../common/LabeledText';
import {YeastFirestoreService} from '../../firebase';
import {Yeast} from '../../models';
import ItemView, {useItemViewStyles} from '../common/ItemView';


interface Props {
  yeast?: Yeast | null,
  id?: string|null,
}

const YeastView: FunctionComponent<Props> = props => {

  const {id, yeast} = props;

  const classes = useItemViewStyles();

  const renderView = (item: Yeast|null) => {
    return (
      <Fragment>
        <Typography
          className={classes.title}
          variant="h2"
        >
          {item?.name}
        </Typography>
        <Typography
          className={classes.body}
          variant="body1"
        >
          {item?.description}
        </Typography>
        <LabeledText
          label="Picklist Name"
          text={item?.picklistName}
        />
        <LabeledText
          label="Aliases"
          text={item?.aliases && item?.aliases.join(", ")}
        />
        <LabeledText
          label="Created by:"
          text={item?.creator}
        />
        <LabeledLinks label="Links" links={item?.links}/>
      </Fragment>
    );
  };

  return (
    <ItemView
      item={yeast}
      id={id}
      service={YeastFirestoreService}
      viewRenderer={renderView}
    />
  )
};

export default YeastView;
